var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElementList',{on:{"closePopup":function($event){return _vm.$emit('closePopup')},"submitElement":_vm.submitElement}})
}
var staticRenderFns = []

export { render, staticRenderFns }